// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //api_url: "https://api.appclara.com/v1/admin",
  api_url: "https://api-dev.appclara.com/v1/admin",
  //api_url : "http://api-local.in-testing.xyz/admin",
  authorization: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NDU1Nzc2MzksImF1ZCI6IjQzYTNmZmRhODZiYzhkYTgxMzNlMjk0M2E5MzU0ZDllMGViN2ZkYzgiLCJkYXRhIjp7ImlkIjoxLCJ0b2tlbiI6MSwibmFtZSI6IkRNUC1Tb3k1MDItYWRtaW4iLCJncm91cCI6InVzZXJkYnNveSJ9fQ.yRemc_dmzGoGnVleCE3bwKhnFqOAjbvnNZ_CkB1nYm8"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
